import {
  AfterViewInit,
  Component,
  ComponentFactoryResolver,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { CustomActionDirective } from './custom-action.directive';

@Component({
  selector: 'app-custom-action',
  template: `
    <div>
      <custom-action></custom-action>
    </div>
  `,
})
export class CustomActionComponent implements OnInit, AfterViewInit {
  @Input() data;
  @Input() component: { name: any; data: any };
  @Output() onTrigger = new EventEmitter();
  @ViewChild(CustomActionDirective, { static: true })
  csutomAction: CustomActionDirective;

  constructor(private componentFactoryResolver: ComponentFactoryResolver) {}

  ngOnInit(): void {}
  ngAfterViewInit() {
    this.loadActionComponent();
  }

  loadActionComponent() {
    const target = this.csutomAction.viewContainerRef;
    target.clear();
    const widgetComponent =
      this.componentFactoryResolver?.resolveComponentFactory(
        this.component?.name
      );
    const componentRef = target.createComponent(widgetComponent);

    if (this.component?.data) {
      for (const key in this.component?.data) {
        componentRef.instance[key] = this.component?.data[key];
      }
    }
    componentRef.instance['data'] = this.data;
    componentRef.instance['onCustomAction'].subscribe((event) => {
      this.onTrigger.emit(event);
    });
  }
}
